import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=57684c26"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57684c26')) {
      api.createRecord('57684c26', component.options)
    } else {
      api.reload('57684c26', component.options)
    }
    module.hot.accept("./DashboardComponent.vue?vue&type=template&id=57684c26", function () {
      api.rerender('57684c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/DashboardComponent.vue"
export default component.exports